import React, { useState } from "react";
import { connect } from "react-redux";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { BASE_URL } from "../../../_constants/urlConstants";
import { docPermConstants } from "../../../_constants/permissionConstants";

function WebhookTrigger({ title, description, idLabel, endpoint, canEdit }) {
  const [id, setId] = useState("");
  const [firing, setFiring] = useState(false);
  const [result, setResult] = useState(null); // { sent, message } | { error: string }

  const handleClick_fire = async (e) => {
    e.preventDefault();
    if (!id) return;
    setFiring(true);
    setResult(null);
    try {
      const res = await axios.post(`${BASE_URL}/api/WebhookAdmin/${endpoint}/${id}`);
      setResult(res.data);
    } catch (err) {
      const errData = err.response && err.response.data;
      const errMessage = (errData && errData.message) || errData || err.message;
      setResult({ error: errMessage });
    } finally {
      setFiring(false);
    }
  };

  return (
    <div className="card mb-3">
      <div className="card-header">{title}</div>
      <div className="card-body">
        <p className="text-muted">{description}</p>
        <form className="form-inline" onSubmit={handleClick_fire}>
          <label className="mr-2" htmlFor={`${endpoint}_id`}>
            {idLabel}
          </label>
          <input
            type="number"
            id={`${endpoint}_id`}
            name={`${endpoint}_id`}
            className="form-control mr-2"
            style={{ width: "8rem" }}
            value={id}
            onChange={(e) => setId(e.target.value)}
            disabled={!canEdit || firing}
          />
          <button
            type="submit"
            className="btn btn-info"
            disabled={!canEdit || firing || !id}
          >
            <FontAwesomeIcon
              icon={firing ? "spinner" : "paper-plane"}
              spin={firing}
              className="fa-fw mr-1"
            />
            Fire Webhook
          </button>
        </form>
        {result && (
          <div
            className={`alert mt-3 mb-0 ${
              result.error || result.sent === false ? "alert-danger" : "alert-success"
            }`}
          >
            {result.error || result.message}
          </div>
        )}
      </div>
    </div>
  );
}

function AdminWebhooks({ permissions }) {
  // Only SYSADMIN has DELETE on ADMIN_TASKS - DISTADMIN/office admin does not. AdminMain
  // already hides this tab from non-sysadmins; this is a second layer of defense.
  const canEdit = permissions.includes(docPermConstants.DELETE);

  return (
    <React.Fragment>
      <h2 className="mb-1">Webhooks</h2>
      <hr className="mt-0 mb-2" />
      <div className="alert alert-info">
        <FontAwesomeIcon icon="info-circle" className="fa-fw mr-2" />
        Manually re-fire the Daily Report Submitted webhook for a specific ADR,
        independent of the automatic trigger on Daily Report submit. Useful for
        controlled testing against the production endpoint. ProjectAssignmentUpdated
        has no manual trigger; it fires only when a staff update newly assigns the RE role.
      </div>
      <WebhookTrigger
        title="Daily Report Submitted"
        description="Re-sends the DailyReportSubmitted webhook payload (report header + photo attachments) for the given ADR. No-ops if the ADR has no photo attachments with EXIF data (GPS coordinates and/or date taken)."
        idLabel="ADR ID"
        endpoint="DailyReportSubmitted"
        canEdit={canEdit}
      />
    </React.Fragment>
  );
}

const mapStateToProps = (state) => ({
  user: state.authentication.user,
});

export default connect(mapStateToProps)(AdminWebhooks);
